module.exports = __webpack_public_path__ + "img/banner-8.36066d50.jpg";